import marketingCampaigns from './MarketingCampaigns.view';
import CampaignPromoView from './CampaignPromoView.view';

export default marketingCampaigns;
export { CampaignPromoView };